/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'

@Injectable({
  providedIn: 'root',
})
export class MyProfileAddressHelperService {
  /* ng-dynamic-forms doesn't trigger the form validation on submit automatically so we need to do it ourselves.
  However, we just want to touch the enabled controls as otherwise the form is considered invalid if disabled
  controls are being evaluated too. Controls which are being hidden are also disabled for the same reason.
  Disabled controls can occur at any nesting level (e.g. the company fields inside a group on a private address),
  so we walk the tree recursively and skip every disabled control — touching or focus/blurring a disabled field
  would surface validation errors and block submission for fields that don't apply to the selected address type.
  */
  static triggerFormValidationErrors(formGroup: UntypedFormGroup) {
    MyProfileAddressHelperService.validateEnabledControls(formGroup)
  }

  private static validateEnabledControls(group: UntypedFormGroup) {
    Object.entries(group.controls).forEach(([controlName, control]) => {
      if (control.disabled) {
        return
      }

      if (control instanceof UntypedFormGroup) {
        MyProfileAddressHelperService.validateEnabledControls(control)
        return
      }

      control.markAsTouched()

      const element = document.querySelector(`[name="${controlName}"]`) as HTMLElement | null
      if (element) {
        element.focus()
        element.blur()
      }
    })
  }

  // Structure the data correctly so that the api can make sense of it
  static prepareAddressPayload(formGroup: UntypedFormGroup, addressIdBeingEdited: string | null) {
    const result: any = {}

    Object.entries(formGroup.controls).forEach(([ctrlKey, ctrlValue]) => {
      if (ctrlValue instanceof UntypedFormGroup) {
        Object.entries(ctrlValue.value).forEach(([key, value]) => {
          if (value !== '') {
            result[key] = value
          } else {
            result[key] = undefined
          }
        })
      } else {
        result[ctrlKey] = ctrlValue.value
      }
    })

    result.addressId = addressIdBeingEdited
    return result
  }

  static getStringWithoutDashes(input: string | null): string | null {
    const reg = new RegExp('[-]+', 'g')
    return input ? input.replace(reg, '') : null
  }
}
